
export const APP_GROUP_LINKS = {
	BASE: '/app',
	CONFIRM_EMAIL: '/confirm-email'
};

